import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { BackButton, Button, Title, Input, SelectItem, SelectShed } from '../../../../components/UI/ComponentsUI';
import { translate, closeCollapsible, formatData, showMessageToastCustom, isNullOrEmpty, getUserNameToName } from '../../../../utils/util';
import CollapsibleUI from '../../../../components/UI/CollapsibleUI';
import InfiniteScrollUl from '../../../../components/UI/InfiniteScrollUl';
import { onValueChange } from '../../../../utils/handleChangeHooks';
import M from 'materialize-css/dist/js/materialize';
import ConfirmModal from '../../../../components/UI/ConfirmModal';
import ScannerCode from '../../../../components/UI/ScannerCode';
import TruckKanbanService from '../../../../services/TruckKanbanService';
import * as actionsTruckKanban from '../../../../actions/truckKanbanAction';

const ShedAreaList = (props) => {
    const [shedAreas, setShedAreas] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemDelete, setItemDelete] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    const [filter, setFilter] = useState({
        qme: '',
        partNumberCode: '',
        excluded: false
    });

    useEffect(() => {
        if (props.shedAreaPaged?.items?.length > 0) {
            if (shedAreas.length > 0 && currentPage === 0) {
                setShedAreas([...props.shedAreaPaged.items]);
            } else {
                setShedAreas((prevState) => ([...prevState, ...props.shedAreaPaged.items]));
            }
        } else {
            setShedAreas([]);
        }
        // eslint-disable-next-line
    }, [props?.shedAreaPaged?.items]);

    useEffect(() => {
        getFilter();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (currentPage > 0) {
            getFilter(false);
        }
        // eslint-disable-next-line
    }, [currentPage]);

    const getFilter = (click) => {
        var currentPageList = click ? 0 : currentPage;
        if (click) {
            setCurrentPage(0);
        }

        props.getshedAreas(Object.assign(filter, {
            PageSize: 25,
            PageIndex: currentPageList
        }), () => {
            closeCollapsible("filterShedArea")
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onDelete = () => {
        props.deleteShedArea(itemDelete.id, (response) => {
            if (response) {
                showMessageToastCustom(translate('general.info'), translate('sucess-to-delete', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                getFilter(true);
            }

            setItemDelete(null);
        });
    }

    const onDeleteSelected = () => {
        props.deleteSelected(selectedItems, (response) => {
            if (response) {
                showMessageToastCustom(translate('general.info'), translate('sucess-to-delete', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                getFilter(true);
            }

            setSelectedItems([]);
        });
    }

    const onClickDelete = (item) => {
        setItemDelete(item)
        const modal = M.Modal.init(document.getElementById('confirmDelete'));
        modal.open();
    }

    const onSelectItem = (item) => {
        props.setShedArea(item)
        props.history.push({
            pathname: './Insert',
            state: { update: true }
        })
    }

    const onCheckItem = (item) => {
        let arr = [];
        Object.assign(arr, selectedItems);
        let index = selectedItems.findIndex((e) => e === item.id);
        if (index === -1) {
            arr.push(item.id)
        } else {
            arr.splice(index, 1);
        }
        setSelectedItems(arr)
    }

    const deleteSelectedItems = () => {
        const modal = M.Modal.init(document.getElementById('confirmDeleteSelected'));
        modal.open();
    }

    const onChangeData = (value) => {
        if (!isNullOrEmpty(value)) {
            filter.createdBy = value;
            setFilter(filter);
        }
    };

    const scanner = (value) => {
        filter.createdBy = value;
        setFilter(filter);
    };

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <Title icon="mdi mdi-clipboard-list-outline" label={translate('shed-area-list', 'truck-kanban')} />
            </div>
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px', }}>
                    <CollapsibleUI
                        id="filterShedArea"
                        header={translate('filter', 'physical-confirmation')}
                        body={
                            <div className="row" style={{ padding: '10px' }}>
                                <div className="input-field no-padding col s12">
                                    <SelectShed
                                        unload
                                        id="shed"
                                        required
                                        name="shed"
                                        value={filter.shed}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s5">
                                    <Input
                                        id="area"
                                        name='area'
                                        placeholder={translate('area', 'physical-confirmation')}
                                        type="text"
                                        value={filter?.area || ''}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s6">
                                    <ScannerCode className={"mdi mdi-qrcode posfix"} onScanner={scanner} />
                                    <SelectItem
                                        id="user"
                                        name="user"
                                        label={translate('plant:fields.user')}
                                        onChange={(event) => scanner(event.target?.value)}
                                        onChangeData={onChangeData}
                                        data={props.usersFromElog ? props.usersFromElog.map(item => {
                                            return {
                                                id: item.id,
                                                text: item.user
                                            }
                                        }) : []} />

                                </div>
                            </div>

                        }
                    />
                    <div className="row" style={{ paddingTop: '3px' }}>
                        <Button
                            full="true"
                            text={translate('search', 'general')}
                            onClick={() => getFilter(true)} />
                    </div>
                </div>
                {selectedItems.length > 0 &&
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button full="true" text="Excluir Selecionados" onClick={() => deleteSelectedItems()} />
                    </div>
                }
                <InfiniteScrollUl
                    page={props.shedAreaPaged.totalPages}
                    current={{ currentPage, setCurrentPage }}
                    hasMore={currentPage < props.shedAreaPaged.totalPages}
                    data={!shedAreas ? [] : shedAreas?.map((item) => (
                        <div key={item?.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0px 10px' }} >
                            <div onClick={() => onSelectItem(item)}>
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    {translate('shed', 'resource')}: {item?.shed || ''}
                                </span>
                                <span className="title sixth-text-color" style={{ display: 'block' }} >
                                    {translate('area', 'physical-confirmation')}: {item?.area || ''}
                                </span>
                                <span className="sixth-text-color" style={{ marginLeft: '10px', display: 'block' }}>{formatData(item?.updatedOn)}</span>
                                <span className="sixth-text-color" style={{ marginLeft: '10px' }}>{getUserNameToName(props.usersFromElog, item?.updatedBy)}</span>
                            </div>
                            <div>
                                <span className="title sixth-text-color" style={{ display: 'block' }}>
                                    <i style={{ cursor: 'pointer' }} onClick={() => onClickDelete(item)} className="mdi mdi-delete"></i>
                                </span>
                                <span className="title sixth-text-color" style={{ display: 'block' }}>
                                    <Input
                                        type="checkbox"
                                        onChange={() => onCheckItem(item)}
                                        id="select"
                                        name="select"
                                    />
                                </span>
                            </div>
                        </div>
                    ))}
                />
            </div>
            <ConfirmModal
                id="confirmDelete"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={onDelete}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            />
            <ConfirmModal
                id="confirmDeleteSelected"
                data={{ title: translate('validations:attention'), message: translate("token.confirmation-delete", "configuration") }}
                onConfirm={onDeleteSelected}
                btnCancel={translate('general:cancel')}
                btnConfirm={translate('general:confirm')}
            />
        </div>
    );
}

const getListSelectUser = (usersElog) => {
    let users = [];
    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.userName,
        });
    });

    usersElog.forEach(item => {
        users.push({
            id: item.userName,
            user: item.name,
        });
    });

    return users;
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
        shedAreaPaged: state.truckKanbanReducer.shedAreaPaged,
        usersFromElog: getListSelectUser(state.usersElogReducer.usersElog),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getshedAreas: (filter, callback) => {
            dispatch(TruckKanbanService.getShedAreaPaged(filter, callback));
        },
        deleteShedArea: (id, callback) => {
            dispatch(TruckKanbanService.deleteShedArea(id, callback));
        },
        deleteSelected: (selectedIds, callback) => {
            dispatch(TruckKanbanService.deleteShedAreaSelected(selectedIds, callback));
        },
        setShedArea: (shedArea) => {
            dispatch(actionsTruckKanban.setShedArea(shedArea));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ShedAreaList));